import { createContext } from 'react';

import { SHOW_THRESHOLD_INDICATORS_DEFAULT } from '../constants.js';

export const GaugeChartShowThresholdIndicatorsContext = createContext<boolean>(
  SHOW_THRESHOLD_INDICATORS_DEFAULT,
);
